import { Box, BoxProps } from '@mui/material';
import * as React from 'react';

export interface FlexboxProps extends Omit<BoxProps, 'ref'> {
    gap?: string | number;
}

export const Flexbox = React.forwardRef<HTMLDivElement, FlexboxProps>(({ gap, style = {}, ...rest }, ref) => {
    return <Box ref={ref} style={{ display: 'flex', gap, ...style }} {...rest} />;
});
